import axios from '@/plugins/axios.js'

export function remove(id) {
    return axios.delete(`erp/stock/${id}`);
}

export function list(params) {
    return axios.get("erp/stock", { params: params });
}